export default "__VITE_ASSET__D_uIP3bQ__"